import { useTransformEvent } from '@ion/api';
import buildEditorPlaybook from './buildEditorPlaybook';

export default function usePlaybookStageOutput({ editorPlaybook, revisionMeta, attachment, clusterId }) {
  const [transformEvent, { loading, error, outputEvent, errors, reset }] = useTransformEvent();

  const executePlaybookTransform = ({ inputEvent, originalEvent }) => {
    transformEvent({
      playbook: buildEditorPlaybook({ editorPlaybook, revisionMeta, attachment }),
      inputEvent,
      originalEvent,
      clusterId,
    });
  };

  return [executePlaybookTransform, { loading, error, outputEvent, errors, reset }];
}
